import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CompareVehicleTrayMap } from 'client/tracking/maps/common/compare-vehicle-tray';
import { EditorialMap } from 'client/tracking/maps/editorial';
import { CommonMap } from 'client/tracking/maps/common';

const map = {
  best_subnav_view_content: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_SUBNAV_CONTENT
  ),
  best_vehicle_read_more: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.READ_MORE
  ),
  best_vehicle_see_more_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SEE_MORE
  ),
  best_vehicle_see_more_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SEE_MORE
  ),
  view_best_lease: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_PRICING_DETAILS,
    TrackingConstant.OEM_LEASE_DEAL
  ),
};

export const BestMap = {
  ...CommonMap,
  ...EditorialMap,
  ...CompareVehicleTrayMap,
  ...map,
};
